import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Icon from '@components/Icon';
import SEO from '@components/seo/SEO';
import { BackTop, Drawer } from 'antd';

// 创建图标封装组件，与LandingPage中相同
const SafeIcon = ({ icon: IconName, useFa = true, ...props }) => {
  if (typeof IconName === 'string' && Icon[IconName]) {
    const IconComponent = Icon[IconName];
    return <IconComponent useFa={useFa} {...props} />;
  }
  
  if (typeof IconName === 'function' || typeof IconName === 'object') {
    return <IconName useFa={useFa} {...props} />;
  }
  
  return null;
};

const Copyright = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-b from-purple-50 to-blue-50 dark:from-gray-900 dark:to-gray-800">
      <SEO 
        title="版权声明 - 图美啦知识产权保护政策 | 在线图片美化工具"
        description="图美啦版权声明与知识产权保护政策。了解我们的版权信息、用户上传内容的权利义务，以及如何处理侵权投诉。"
        keywords="图美啦版权声明,知识产权保护,侵权投诉,用户上传内容,图片版权,在线工具版权"
        canonicalUrl="https://snapbeautify.toolooz.com/copyright"
      />
      {/* 导航栏 */}
      <header className="bg-white dark:bg-gray-900 shadow-sm">
        <div className="container mx-auto px-4 py-3">
          <div className="flex justify-between items-center">
            <div className="flex items-center">
              <Link to="/" className="flex items-center text-2xl font-bold text-purple-600 dark:text-purple-400">
                <img src="/favicon.svg" alt="图美啦" width="32" height="32" className="mr-2" />
                图美啦
              </Link>
            </div>
            <nav className="hidden md:flex space-x-8">
              <Link to="/" className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center">
                <SafeIcon icon="Home" size={16} className="mr-1" />
                首页
              </Link>
              <Link to="/quick-start" className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center">
                <SafeIcon icon="BookOpen" size={16} className="mr-1" />
                快速上手
              </Link>
              <Link to="/about" className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center">
                <SafeIcon icon="User" size={16} className="mr-1" />
                关于我们
              </Link>
            </nav>
            <div className="flex md:hidden">
              <button 
                className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
                onClick={() => setMobileMenuOpen(true)}
              >
                <SafeIcon icon="Menu" size={24} />
              </button>
            </div>
          </div>
        </div>
        
        {/* 移动设备导航菜单 */}
        <Drawer
          title="导航菜单"
          placement="right"
          onClose={() => setMobileMenuOpen(false)}
          open={mobileMenuOpen}
          width={250}
        >
          <div className="flex flex-col space-y-4">
            <Link 
              to="/" 
              className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center py-2"
              onClick={() => setMobileMenuOpen(false)}
            >
              <SafeIcon icon="Home" size={16} className="mr-1" />
              首页
            </Link>
            <Link 
              to="/quick-start" 
              className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center py-2"
              onClick={() => setMobileMenuOpen(false)}
            >
              <SafeIcon icon="BookOpen" size={16} className="mr-1" />
              快速上手
            </Link>
            <Link 
              to="/about" 
              className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center py-2"
              onClick={() => setMobileMenuOpen(false)}
            >
              <SafeIcon icon="User" size={16} className="mr-1" />
              关于我们
            </Link>
            <Link 
              to="/features" 
              className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center py-2"
              onClick={() => setMobileMenuOpen(false)}
            >
              <SafeIcon icon="Star" size={16} className="mr-1" />
              功能介绍
            </Link>
            <Link 
              to="/faq" 
              className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center py-2"
              onClick={() => setMobileMenuOpen(false)}
            >
              <SafeIcon icon="HelpCircle" size={16} className="mr-1" />
              常见问题
            </Link>
            <div className="border-t border-gray-200 dark:border-gray-700 my-2 pt-2">
              <Link 
                to="/privacy" 
                className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                <SafeIcon icon="Shield" size={16} className="mr-1" />
                隐私政策
              </Link>
              <Link 
                to="/terms" 
                className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                <SafeIcon icon="FileText" size={16} className="mr-1" />
                使用条款
              </Link>
              <Link 
                to="/copyright" 
                className="font-medium text-purple-600 dark:text-purple-400 flex items-center py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                <SafeIcon icon="Award" size={16} className="mr-1" />
                版权声明
              </Link>
            </div>
          </div>
        </Drawer>
      </header>

      {/* 主要内容区域 */}
      <main className="flex-grow container mx-auto px-4 py-8">
        <div className="max-w-4xl mx-auto bg-white dark:bg-gray-800 rounded-xl shadow-lg overflow-hidden">
          <div className="p-8">
            <h1 className="text-3xl font-bold text-gray-800 dark:text-white mb-6 flex items-center">
              <SafeIcon icon="Award" className="mr-3 text-purple-600 dark:text-purple-400" size={28} />
              版权声明
              <span className="text-sm font-normal text-gray-500 dark:text-gray-400 ml-4">更新日期: 2025年3月22日</span>
            </h1>

            <div className="prose dark:prose-invert max-w-none">
              <p className="text-gray-600 dark:text-gray-300">
                图美啦尊重知识产权，并期望我们的用户也尊重知识产权。本版权声明旨在明确图美啦及其用户在知识产权方面的权利和责任。
              </p>

              <h2 className="text-xl font-semibold mt-8 mb-4 text-gray-800 dark:text-white flex items-center">
                <SafeIcon icon="Copyright" className="mr-2 text-purple-500 dark:text-purple-400" size={20} />
                图美啦的知识产权
              </h2>
              <p className="text-gray-600 dark:text-gray-300">
                图美啦网站及其内容，包括但不限于文本、图形、用户界面、视觉界面、图片、商标、标志、声音、音乐、艺术作品和计算机代码（统称"内容"），包括但不限于内容的设计、结构、选择、协调、表达、外观和感觉、排列，均由图美啦拥有、控制或许可，并受版权、商标、专利和其他知识产权和不正当竞争法的保护。
              </p>
              <p className="text-gray-600 dark:text-gray-300 mt-4">
                除非本版权声明或网站上明确说明，否则未经图美啦事先书面许可，不得以任何方式或通过任何媒介复制、重现、修改、出版、上传、张贴、传输、分发、展示、执行、广播或以其他方式利用图美啦网站上的任何内容。
              </p>

              <h2 className="text-xl font-semibold mt-8 mb-4 text-gray-800 dark:text-white flex items-center">
                <SafeIcon icon="Upload" className="mr-2 text-purple-500 dark:text-purple-400" size={20} />
                用户上传内容
              </h2>
              <p className="text-gray-600 dark:text-gray-300">
                当您将图片上传到图美啦进行处理时，您保留对这些图片的所有权利。您只需授予我们有限的许可，允许我们处理这些图片并为您提供服务。
              </p>
              <p className="text-gray-600 dark:text-gray-300 mt-4">
                您必须确保您上传的内容不侵犯任何第三方的知识产权。这意味着您应该：
              </p>
              <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 space-y-2">
                <li>只上传您自己创建的图片，或者您有权使用和修改的图片</li>
                <li>不上传含有受版权保护的人物、标志、商标或其他专有内容的图片，除非您拥有相应权利或已获得许可</li>
                <li>尊重他人的知识产权，包括著作权、商标权和肖像权</li>
              </ul>

              <h2 className="text-xl font-semibold mt-8 mb-4 text-gray-800 dark:text-white flex items-center">
                <SafeIcon icon="AlertTriangle" className="mr-2 text-purple-500 dark:text-purple-400" size={20} />
                侵权投诉
              </h2>
              <p className="text-gray-600 dark:text-gray-300">
                图美啦尊重他人的知识产权，并要求我们的用户也这样做。如果您认为有内容侵犯了您的知识产权，请您通过以下方式联系我们：
              </p>
              <p className="text-gray-600 dark:text-gray-300 mt-2 flex items-center">
                <SafeIcon icon="Mail" size={16} className="mr-2 text-purple-500 dark:text-purple-400" />
                <a href="mailto:support@toolooz.com" className="text-purple-600 dark:text-purple-400 hover:underline">support@toolooz.com</a>
              </p>
              <p className="text-gray-600 dark:text-gray-300 mt-4">
                在您的投诉中，请提供以下信息：
              </p>
              <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 space-y-2">
                <li>您认为被侵权的作品的描述</li>
                <li>您认为侵权的材料的描述和位置</li>
                <li>您的联系信息，包括地址、电话号码和电子邮件地址</li>
                <li>您真诚地相信被投诉使用未经版权所有者、其代理人或法律授权的声明</li>
                <li>在伪证处罚下，您是版权所有者或授权代表版权所有者行事的声明</li>
                <li>您的实体或电子签名</li>
              </ul>
              <p className="text-gray-600 dark:text-gray-300 mt-4">
                收到符合上述要求的通知后，我们将采取适当行动，包括移除或禁用访问被指控侵权的内容。
              </p>

              <h2 className="text-xl font-semibold mt-8 mb-4 text-gray-800 dark:text-white flex items-center">
                <SafeIcon icon="Layout" className="mr-2 text-purple-500 dark:text-purple-400" size={20} />
                图美啦提供的素材
              </h2>
              <p className="text-gray-600 dark:text-gray-300">
                图美啦可能提供一些设计元素、模板、背景或其他设计资源供用户使用。这些素材的使用受以下条件限制：
              </p>
              <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 space-y-2">
                <li>您可以在图美啦平台内使用这些素材来创建和编辑您的图片</li>
                <li>您可以在个人和商业项目中使用您创建的最终图片</li>
                <li>您不得单独提取、下载或分发这些素材</li>
                <li>您不得声称这些素材为您自己的创作，或者基于这些素材创建竞争性服务</li>
              </ul>
              <p className="text-gray-600 dark:text-gray-300 mt-4">
                请注意，某些素材可能来自第三方提供商，并可能受额外许可条款的约束。在这种情况下，相关的许可条款将在使用时提供给您。
              </p>

              <h2 className="text-xl font-semibold mt-8 mb-4 text-gray-800 dark:text-white flex items-center">
                <SafeIcon icon="Briefcase" className="mr-2 text-purple-500 dark:text-purple-400" size={20} />
                商标
              </h2>
              <p className="text-gray-600 dark:text-gray-300">
                "图美啦"、"SnapBeautify"以及相关的名称、标志、产品和服务名称、设计和口号是图美啦的商标或注册商标。您不得在未经我们事先书面许可的情况下使用这些商标。
              </p>
              <p className="text-gray-600 dark:text-gray-300 mt-4">
                此外，图美啦网站上可能出现的其他商标、名称或标志是其各自所有者的财产。提及任何第三方的产品、服务、流程或其他信息并不构成或暗示我们的认可、赞助或推荐。
              </p>

              <h2 className="text-xl font-semibold mt-8 mb-4 text-gray-800 dark:text-white flex items-center">
                <SafeIcon icon="Globe" className="mr-2 text-purple-500 dark:text-purple-400" size={20} />
                国际用户
              </h2>
              <p className="text-gray-600 dark:text-gray-300">
                图美啦由中国境内的实体拥有和运营。我们不保证图美啦或其任何内容在其他地区适当或可用。访问图美啦的用户自愿这样做，并有责任遵守当地法律。
              </p>

              <h2 className="text-xl font-semibold mt-8 mb-4 text-gray-800 dark:text-white flex items-center">
                <SafeIcon icon="Edit" className="mr-2 text-purple-500 dark:text-purple-400" size={20} />
                变更
              </h2>
              <p className="text-gray-600 dark:text-gray-300">
                我们保留随时修改本版权声明的权利。修改后的版权声明将在网站上公布，并在公布后立即生效。我们鼓励用户定期查看本版权声明，以了解任何变更。
              </p>

              <h2 className="text-xl font-semibold mt-8 mb-4 text-gray-800 dark:text-white flex items-center">
                <SafeIcon icon="MessageCircle" className="mr-2 text-purple-500 dark:text-purple-400" size={20} />
                联系我们
              </h2>
              <p className="text-gray-600 dark:text-gray-300">
                如果您对本版权声明有任何问题或建议，请随时联系我们：
              </p>
              <p className="text-gray-600 dark:text-gray-300 mt-2 flex items-center">
                <SafeIcon icon="Mail" size={16} className="mr-2 text-purple-500 dark:text-purple-400" />
                <a href="mailto:support@toolooz.com" className="text-purple-600 dark:text-purple-400 hover:underline">support@toolooz.com</a>
              </p>
            </div>
          </div>
        </div>
      </main>

      {/* 页脚区域 */}
      <footer className="bg-gray-800 text-white py-8">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="mb-4 md:mb-0">
              <Link to="/" className="flex items-center text-xl font-bold text-white">
                <img src="/favicon.svg" alt="图美啦" width="24" height="24" className="mr-2" />
                图美啦
              </Link>
            </div>
            
            <div className="flex space-x-8">
              <Link to="/privacy" className="text-gray-300 hover:text-white transition-colors text-sm">隐私政策</Link>
              <Link to="/terms" className="text-gray-300 hover:text-white transition-colors text-sm">使用条款</Link>
              <Link to="/copyright" className="text-gray-300 hover:text-white transition-colors text-sm">版权声明</Link>
            </div>
            
            <div className="mt-4 md:mt-0 text-gray-400 text-sm">
              © {new Date().getFullYear()} 图美啦 | SnapBeautify
            </div>
          </div>
        </div>
      </footer>
      
      <BackTop>
        <div className="flex items-center justify-center w-10 h-10 rounded-full bg-purple-600 hover:bg-purple-700 text-white shadow-lg">
          <SafeIcon icon="ChevronUp" size={20} />
        </div>
      </BackTop>
    </div>
  );
};

export default Copyright; 